import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChevronDown } from "lucide-react";
import { PortfolioItem } from "@/hooks/profile";
import ProjectDetailsFields from "../components/ProjectDetailsFields";

interface ShotDetailsCardProps {
  item: PortfolioItem;
  onChange: (item: PortfolioItem) => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  imageUrls: string[];
  userProfession?: string;
  userSkills?: string[];
  isAutoGenerating?: boolean;
  detectedElements?: string[];
}

export const ShotDetailsCard: React.FC<ShotDetailsCardProps> = ({
  item,
  onChange,
  isCollapsed,
  onToggleCollapse,
  imageUrls,
  userProfession = 'designer',
  userSkills = [],
  isAutoGenerating = false,
  detectedElements = []
}) => {
  return (
    <Card className="mb-6">
      <CardHeader
        className="cursor-pointer hover:bg-gray-50/50 transition-colors"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center justify-between">
          <CardTitle className="text-base text-gray-500">Shot Details</CardTitle>
          <ChevronDown
            className={`h-5 w-5 text-gray-500 transition-transform duration-200 ${
              isCollapsed ? '' : 'rotate-180'
            }`}
          />
        </div>
      </CardHeader>
      {!isCollapsed && (
        <CardContent className="space-y-4">
          <ProjectDetailsFields
            item={item}
            onChange={onChange}
            imageUrls={imageUrls}
            userProfession={userProfession}
            userSkills={userSkills}
            isAutoGenerating={isAutoGenerating}
            detectedElements={detectedElements}
          />
        </CardContent>
      )}
    </Card>
  );
};
